/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract, UtilService } from '@dm/core';
import { type NFSClient } from 'app/common/types/mo';

import { ClientType } from '../../nfs-share.enum';
import { NfsShareStrService } from '../../nfs-share-str.service';
import { ClientNfsShareService } from '../client-nfs-share.service';

@Component({
    selector: 'app-remove-client-nfs-share',
    templateUrl: './remove-client-nfs-share.component.html',
    styleUrls: ['./remove-client-nfs-share.component.scss'],
})
export class RemoveClientNfsShareComponent extends DeleteAbstract<NFSClient> {
    i18n = this.str.i18n;

    constructor(
        private str: NfsShareStrService,
        private service: ClientNfsShareService,
        injector: Injector,
        private utilService: UtilService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.label.client,
                filterType: 'search',
                render: (value: string): string => {
                    // 如果是网络组，会多一个@符号
                    if (value.charAt(0) === '@') {
                        return value.substr(1);
                    }
                    return value;
                },
            },
            {
                field: '_type',
                header: this.i18n.label.type,
                columnFilter: true,
                filterType: 'dropdown',
                options: this.str.clientTypeOpts,
                render: (value): string => this.utilService.getLabelFromOptions(this.str.clientTypeOpts, value),
            },
        ];
    }


    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-remove-client-nfs-share-highRisk-removeClient',
                canHidden: true,
                opType: 'warning',
                title: this.i18n.title.removeClient,
                content: this.i18n.highRisk.removeClient,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((data) => ({
            name: this.i18n.rest.removeClients,
            nameParams: [data._type === ClientType.host ? this.i18n.value.host : this.i18n.value.net, data.NAME.replace('@', '')],
            action: this.service.remove(data.ID, data.vstoreId),
        }));

        return cmds;
    }
}
